<!-- Ladeindikator -->
<div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
        <cds-progress-circle size="xl" status="info"></cds-progress-circle>
        <p>Daten werden geladen …</p>
    </div>
</div>

<div class="statistics-overview" *ngIf="statistics">
    <div class="statistic-item">
        <span class="statistic-label">Gesamtanzahl Sendungen</span>
        <span class="statistic-value">{{ statistics.broadcastCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Gesamtanzahl mit KIUT-Flag</span>
        <span class="statistic-value">{{ statistics.broadcastKiutCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Gesamtanzahl mit IsPretranscribed-Flag</span>
        <span class="statistic-value">{{ statistics.vodCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Gesamtanzahl erfolgreich LIVE-Transkripiert</span>
        <span class="statistic-value">{{ statistics.liveCount }}</span>
    </div>
    <div class="statistic-item">
        <span class="statistic-label">Gesamtanzahl Fehler bei LIVE-Transkription</span>
        <span class="statistic-value">{{ statistics.liveFailedCount }}</span>
    </div>
</div>

<clr-datagrid *ngIf="statistics" [clrDgLoading]="false" [clrDgColumnResize]="false">
    <clr-dg-column class="fixed-column">Datum</clr-dg-column>
    <clr-dg-column class="fixed-column">KIUT</clr-dg-column>
    <clr-dg-column class="fixed-column">%</clr-dg-column>
    <clr-dg-column class="fixed-column">isPretranscribed</clr-dg-column>
    <clr-dg-column class="key-column col-key">Key</clr-dg-column>
    <clr-dg-column clrDgField="title">Titel der Sendung</clr-dg-column>
    <clr-dg-column class="key-column col-wav">WAV</clr-dg-column>

    <clr-dg-row *clrDgItems="let broadcast of broadcastList()" [clrDgItem]="broadcast">
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.programmDate }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.kiut }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.percentageTranscribed }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell fixed-column">
            {{ broadcast.isPretranscribed }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell key-column col-key ellipsis" [title]="broadcast.key">
            {{ broadcast.key }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell ellipsis">
            {{ broadcast.title }}
        </clr-dg-cell>
        <clr-dg-cell class="text-cell key-column col-wav ellipsis" [title]="broadcast.wavKey">
            {{ broadcast.wavKey }}
        </clr-dg-cell>
    </clr-dg-row>

    <clr-dg-footer>
        <div class="statistics-footer">
            <button class="btn btn-sm btn-primary" (click)="exportToCsv()">
                <cds-icon shape="download" solid></cds-icon>
                Exportieren
            </button>
            <span>{{ broadcastList().length }} Transkriptionen</span>
        </div>
    </clr-dg-footer>
</clr-datagrid>

<!-- Overlay Editor Panel -->
<app-overlay-panel *ngIf="editorVisible" mode="center" size="xl"
                   ariaLabel="Transkription bearbeiten" (closed)="closeEditor()">
    <span overlay-title>
      <span class="op-title-main">{{ selectedBroadcast?.title }}</span>
      <span class="op-title-sub" *ngIf="selectedBroadcast?.subtitle">{{ selectedBroadcast?.subtitle }}</span>
    </span>
    <app-transcription-editor [broadcast]="selectedBroadcast"></app-transcription-editor>
</app-overlay-panel>
